import http from "@/utils/axios";
import cookie from "@/utils/cookie";

const state = {
  userId:null,
  type:'',

}
const mutations = {
  setUserId(state,obj){
    state.userId = obj.userId;
  },
  clearUserId(state){
    state.userId = null;
  },
  setType(state,obj){
    state.type = obj.type;
  },
  clearType(state){
    state.type = '';
  },


}
const actions = {
  setUserId:({commit, state}, obj) => commit("setUserId", obj),
  clearUserId:({commit, state}, obj) => commit("clearUserId", obj),
  setType:({commit, state}, obj) => commit("setType", obj),
  clearType:({commit, state}, obj) => commit("clearType", obj),

}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/MemberManageModule.js